import { TablePage } from 'web-mojo';
import { FirmwareBuildList } from '@portal/models/FirmwareBuild.js';
import './views/FirmwareBuildView.js';

export default class FirmwareBuildsPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Firmware Builds',
            icon: 'bi-cpu',
            pageName: 'firmware_builds',
            route: 'global/firmware/builds',
            // sys. prefix = user-level-only check; FirmwareBuild is fleet-global
            // (groupless) so member-level grants must not open this page.
            permissions: ['sys.manage_firmware', 'sys.view_cam_devices', 'sys.manage_cam_devices'],

            Collection: FirmwareBuildList,

            defaultQuery: {
                sort: '-created',
            },

            columns: [
                {
                    label: 'Board',
                    key: 'board',
                    filter: { type: 'input' },
                },
                {
                    label: 'Product',
                    key: 'product',
                    filter: { type: 'input' },
                },
                {
                    label: 'Customer',
                    key: 'customer',
                    filter: { type: 'input' },
                    visibility: 'md',
                },
                {
                    label: 'Channel',
                    key: 'channel',
                    formatter: 'badge:stable=success,beta=info,dev=secondary',
                    filter: {
                        type: 'select',
                        options: [
                            { label: 'Stable', value: 'stable' },
                            { label: 'Beta', value: 'beta' },
                            { label: 'Dev', value: 'dev' },
                        ]
                    },
                },
                {
                    label: 'Version',
                    key: 'version',
                },
                {
                    label: 'State',
                    key: 'state',
                    formatter: 'badge:pending=warning,published=success,yanked=danger',
                    filter: {
                        type: 'select',
                        options: [
                            { label: 'Pending', value: 'pending' },
                            { label: 'Published', value: 'published' },
                            { label: 'Yanked', value: 'yanked' },
                        ]
                    },
                },
                {
                    label: 'Git Hash',
                    key: 'git_hash',
                    formatter: (val) => val
                        ? `<span class="font-monospace small text-muted">${String(val).slice(0, 10)}</span>`
                        : '<span class="text-muted small">—</span>',
                    visibility: 'lg',
                },
                {
                    label: 'Created',
                    key: 'created',
                    formatter: 'datetime',
                    visibility: 'md',
                },
            ],

            emptyMessage: 'No firmware builds found.',

            showAdd: false,
            searchable: true,
            sortable: true,
            filterable: true,
            paginated: true,
            showRefresh: true,

            viewDialogOptions: {
                header: false,
                size: 'lg',
            },

            tableOptions: {
                striped: false,
                bordered: false,
                hover: true,
                responsive: true,
            },

            ...options,
        });
    }
}
